import { signOut } from '@/lib/auth';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export function PendingApprovalPage() {
  const { email, profile, refreshProfile } = useAuth();
  const navigate = useNavigate();

  const rejected = profile?.status === 'rejected';
  const inactive = profile?.status === 'approved' && profile?.is_active === false;

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">L</div>
          <div>
            <h1>Liteline Portal</h1>
            <p>
              {rejected
                ? 'Access denied'
                : inactive
                  ? 'Account inactive'
                  : 'Awaiting approval'}
            </p>
          </div>
        </div>

        <div className="pending-body">
          <p>
            Signed in as <code>{email}</code>.
          </p>

          {rejected ? (
            <p>
              An administrator declined this access request. If you think this is a
              mistake, contact the engineering team and ask them to reactivate your
              account.
            </p>
          ) : inactive ? (
            <p>
              An administrator has deactivated this account. Contact the engineering
              team to have it reactivated.
            </p>
          ) : (
            <>
              <p>
                Your account was created successfully but needs to be approved by an
                administrator before you can access the portal.
              </p>
              <p className="muted">
                You&rsquo;ll be able to sign in normally once approved. This page
                refreshes automatically when status changes.
              </p>
            </>
          )}

          <div className="pending-actions">
            <button
              type="button"
              className="btn btn-out"
              onClick={() => {
                void refreshProfile();
              }}
            >
              Check again
            </button>
            <button type="button" className="btn btn-blue" onClick={handleSignOut}>
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
